import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-family-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-family-cm.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationFamilyCmConstants } from "./view-application-family-cm.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ViewApplicationService } from "../../../view-application.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CemeteryService } from "../../../../../shared/services/modules/cemetery.service";
import { AlertType } from "../../../../../shared/models/alert";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationFamilyCmComponent = class ViewApplicationFamilyCmComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    recipientListService;
    appController;
    cemeteryService;
    viewApplicationService;
    changeDetectorRefs;
    familyForm;
    validationMessages = ViewApplicationFamilyCmConstants.VALIDATION_MESSAGES;
    familyFormControlName = ViewApplicationFamilyCmConstants.FAMILY_FORM_CONTROL_NAME;
    familyLabel = ViewApplicationFamilyCmConstants.FAMILY_LABEL;
    familyDisableFilterBy = true;
    familyDisableAdd = false;
    familyDisableEditing = false;
    familyGroups = [];
    familyListLabel = "Family";
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    application;
    getFamilySaveObservableSubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, recipientListService, appController, cemeteryService, viewApplicationService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.cemeteryService = cemeteryService;
        this.viewApplicationService = viewApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        this.familyGroups = stepMeta.familyGroup;
        if (this.familyGroups[0]) {
            this.familyGroups = this.recipientListService.checkStepMetaRecipientGroups(this.familyGroups);
        }
        this.getFamily();
    }
    getFamilyControl() {
        return this.familyForm.get(this.familyFormControlName);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("familyForm");
        this.familyForm = form;
    }
    onBtnSaveClicked($event) {
        if (this.familyForm.valid) {
            const families = this.familyForm.get(this.familyFormControlName).value.recipients;
            families.forEach((family) => {
                family = RecipientUtils.removeRecipientProperties(family);
            });
            const params = {
                family: families
            };
            this.getFamilySaveObservableSubscription =
                this.cemeteryService.getFamilySaveObservable(this.jobID, params)
                    .subscribe({
                    next: (appSaveresponse) => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getFamily();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationFamilyCmConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getFamily() {
        this.cemeteryService
            .getFamiliesObservable(this.jobID)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetFamilyCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationFamilyCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetFamilyCompleted(response) {
        if (response && response.length > 0) {
            const familyControl = this.familyForm.get(this.familyFormControlName);
            const familyList = response;
            this.recipientListService.setRecipients(familyList, false, familyControl);
            this.changeDetectorRefs.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: CemeteryService },
        { type: ViewApplicationService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationFamilyCmComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-family-cm",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationFamilyCmComponent);
export { ViewApplicationFamilyCmComponent };
